import { orgList } from '../api/supportAdmin';
import errorHandle from './errorHandle';

export const getOrganizers = async (serviceType, setOrgData, setLoading) => {
    setLoading(true);
    try {
        const res = await orgList(serviceType);
        setOrgData(res.data);
    } catch (error) {
        errorHandle(error);
    } finally {
        setLoading(false);
    }
};
